module.exports = __webpack_public_path__ + "be24610b3d78ba895440f088222bdfa0.svg";